import React from "react";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { Github } from "lucide-react";
import earthwormLab from "../articles/earthworm-lab";

export default function EarthWormLabArticlePage() {
    const article = earthwormLab;

    return (
        <div className="mx-auto max-w-3xl px-4 py-8">
            <Link to="/articles" className="text-cyan-400 hover:text-cyan-300">
                ← Back to Articles
            </Link>

            <div className="mt-4 flex items-start justify-between gap-4">
                <div>
                    <h1 className="text-3xl font-extrabold text-slate-100">{article.title}</h1>
                    {article.date && <p className="text-sm text-slate-400 mt-1">{article.date}</p>}
                </div>

                {article.repoUrl && (
                    <a
                        href={article.repoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-lg border border-slate-700 px-3 py-2 text-slate-200 hover:bg-slate-800"
                    >
                        <Github className="w-4 h-4" />
                        GitHub
                    </a>
                )}
            </div>

            {article.image && (
                <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-auto rounded-xl border border-slate-700 my-6"
                />
            )}

            {article.summary && <p className="text-slate-200 mb-6">{article.summary}</p>}

            {article.content && (
                <div className="prose prose-invert">
                    <ReactMarkdown>{article.content}</ReactMarkdown>
                </div>
            )}
        </div>
    );
}
